import { Typography } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import {
  AdminListRequestOfBaseFilter,
  ListResponseOfLocationType,
} from "services/KnowfullyAdminClient";
import { MetaValuePreviewProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function LocationTypeDropdownPreview({
  metaValueName,
  attributeMetaValues,
}: MetaValuePreviewProps) {
  const { locationTypeService } = useGlobalContext();

  const storedId = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  const { data } = useQuery<ListResponseOfLocationType>(
    ["locationTypeService.getLocationTypes"],
    () =>
      locationTypeService.getLocationTypes(
        AdminListRequestOfBaseFilter.fromJS({ sortField: "name" }),
      ),
  );

  if (!storedId) return null;

  const item = data?.data?.find(
    (d: { id?: string }) =>
      String(d.id ?? "").toLowerCase() === String(storedId).toLowerCase(),
  );

  return <Typography variant="body2">{item?.name ?? storedId}</Typography>;
}
